export const isTrackingActive = () => {
  if (!Wahanda.Features.isEnabled('CD-176-segment-tracking')) {
    return false;
  }

  return Boolean(window.analytics);
};
